import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CATALOG_REPORT_PRESETS, type CatalogReportPreset } from "@/lib/catalog/report-date-range";

interface CatalogReportDateFiltersProps {
  preset: CatalogReportPreset;
  customFrom: string;
  customTo: string;
  onPresetChange: (preset: CatalogReportPreset) => void;
  onCustomFromChange: (value: string) => void;
  onCustomToChange: (value: string) => void;
}

export function CatalogReportDateFilters({
  preset,
  customFrom,
  customTo,
  onPresetChange,
  onCustomFromChange,
  onCustomToChange,
}: CatalogReportDateFiltersProps) {
  return (
    <div className="space-y-4 rounded-lg border border-slate-200 bg-white p-4">
      <div className="flex flex-wrap gap-2">
        {CATALOG_REPORT_PRESETS.map((option) => (
          <Button
            key={option.id}
            type="button"
            size="sm"
            variant={preset === option.id ? "default" : "outline"}
            onClick={() => onPresetChange(option.id)}
          >
            {option.label}
          </Button>
        ))}
      </div>

      {preset === "custom" ? (
        <div className="grid gap-4 sm:grid-cols-2">
          <div className="space-y-2">
            <Label htmlFor="catalog-report-from">From</Label>
            <Input
              id="catalog-report-from"
              type="date"
              value={customFrom}
              onChange={(event) => onCustomFromChange(event.target.value)}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="catalog-report-to">To</Label>
            <Input
              id="catalog-report-to"
              type="date"
              value={customTo}
              onChange={(event) => onCustomToChange(event.target.value)}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
}
